import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { RootState } from '../../store';
import BookingSettings from './BookingSettings';
import WorkingHoursSettings from './WorkingHoursSettings';
import UsersView from './UsersView';
import ChatSettings from './ChatSettings';
import NotificationSettings from './NotificationSettings';
import IntegrationsSettings from './IntegrationsSettings';

const SettingsView = () => {
  const selectedOrganization = useSelector(
    (state: RootState) => state.organizations.selectedOrganisation
  );
  const isBookingEnabled = selectedOrganization?.isBookingEnabled ?? false;

  return (
    <Box>
      <Routes>
        <Route path="/" element={<UsersView />} />
        <Route path="users" element={<UsersView />} />
        <Route path="integrations" element={<IntegrationsSettings />} />
        <Route path="chat-settings" element={<ChatSettings />} />
        {isBookingEnabled && (
          <>
            <Route path="notifications" element={<NotificationSettings />} />

            <Route path="booking" element={<BookingSettings />} />
            <Route path="working-hours" element={<WorkingHoursSettings />} />
          </>
        )}
      </Routes>
    </Box>
  );
};

export default SettingsView;
